// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "subscription-models-" + chunkId + "-26-18-0.js";
};